import React from "react";
import {
  RiArrowGoBackFill,
  RiLightbulbFill,
  RiRocketFill,
} from "react-icons/ri";
import { BsPeople } from "react-icons/bs";
import { IoGameController, IoPeople } from "react-icons/io5";
import { FaSteam } from "react-icons/fa";
import { PiShareNetworkFill } from "react-icons/pi";
import { FaHeart, FaTrophy } from "react-icons/fa";

import { ReactComponent as AMarkLight } from "../../../Assets/Brand/A-Mark-Light.svg";
import { FaFireFlameCurved } from "react-icons/fa6";

export interface ISuggestedReasonConfig {
  icon: React.ComponentType;
  display: string;
  iconColor: string;
  gradient: string;
}

export const SUGGESTED_REASON_CONFIG: Record<string, ISuggestedReasonConfig> = {
  "Played Together": {
    display: "Recently played with!",
    icon: IoGameController,
    iconColor: "#FFFFFF",
    gradient: "linear-gradient(225deg, #1278A1 0%, #4DBD94 100%)",
  },
  "Steam Friend": {
    display: "Your friend on Steam!",
    icon: FaSteam,
    iconColor: "#FFFFFF",
    gradient: "linear-gradient(135deg, #0c1318 0%, #0c1318 100%)",
  },
  "Common Follower": {
    display: "In your friend network!",
    icon: AMarkLight,
    iconColor: "#FFFFFF",
    gradient: "linear-gradient(130deg, #71AAFF 2.37%, #9A58D1 100%)",
  },
  "Friend of a Friend": {
    display: "You share mutuals!",
    icon: IoPeople,
    iconColor: "#FFFFFF",
    gradient: "linear-gradient(135deg, #71AAFF 0%, #71AAFF 100%)",
  },
  "Extended Network": {
    display: "Your extended network!",
    icon: PiShareNetworkFill,
    iconColor: "#FFFFFF",
    gradient: "linear-gradient(225deg, #1d95c5 0%, #824db1 100%)",
  },
  "Follow Back": {
    display: "Follows you on Allstar!",
    icon: RiArrowGoBackFill,
    iconColor: "#FFFFFF",
    gradient: "linear-gradient(135deg, #f95370 0%, #72439A 100%)",
  },
  "Popular User": {
    display: "Creator trending now!",
    icon: FaFireFlameCurved,
    iconColor: "#FFFFFF",
    gradient: "linear-gradient(225deg, #F95370 0%, #FFA87D 100%)",
  },
  Unspecified: {
    display: "Suggested for you",
    icon: RiLightbulbFill,
    iconColor: "#FFFFFF",
    gradient: "linear-gradient(135deg, #ffad43ff 0%, #f6d543ff 100%)",
  },
  "Followed by Following": {
    display: "You share mutuals!",
    icon: BsPeople,
    iconColor: "#FFFFFF",
    gradient: "linear-gradient(135deg, #71AAFF 0%, #71AAFF 100%)",
  },
  "Rising Star": {
    display: "Rising Star",
    icon: RiRocketFill,
    iconColor: "#FFFFFF",
    gradient: "linear-gradient(135deg, #89f7fe 0%, #66a6ff 100%)",
  },
  Following: {
    display: "From players you follow",
    icon: FaHeart,
    iconColor: "#FFFFFF",
    gradient: "linear-gradient(135deg, #FF6B6B 0%, #4ECDC4 100%)",
  },
  "Played With": {
    display: "Recently played together",
    icon: IoGameController,
    iconColor: "#FFFFFF",
    gradient: "linear-gradient(225deg, #1278A1 0%, #4DBD94 100%)",
  },
  "PRO Player": {
    display: "From PRO players",
    icon: FaTrophy,
    iconColor: "#FFFFFF",
    gradient: "linear-gradient(135deg, #FFD700 0%, #FFA500 100%)",
  },
  "Suggested for you": {
    display: "Suggested for you",
    icon: AMarkLight,
    iconColor: "#FFFFFF",
    gradient: "linear-gradient(135deg, #6B8EFF 0%, #9B6EFF 100%)",
  },
};

export const SUGGESTED_REASON_ICON_MAP: Record<string, React.ComponentType> =
  Object.keys(SUGGESTED_REASON_CONFIG).reduce(
    (acc, key) => {
      acc[key] = SUGGESTED_REASON_CONFIG[key].icon;
      return acc;
    },
    {} as Record<string, React.ComponentType>,
  );
